import React from 'react';
import './svg.css';

const MidStepCircle = (props) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M21.9795 11.9976C21.9795 17.5094 17.5113 21.9776 11.9995 21.9776C6.48773 21.9776 2.01953 17.5094 2.01953 11.9976C2.01953 6.48578 6.48773 2.01758 11.9995 2.01758C17.5113 2.01758 21.9795 6.48578 21.9795 11.9976ZM2.97953 11.9976C2.97953 16.9792 7.01792 21.0176 11.9995 21.0176C16.9811 21.0176 21.0195 16.9792 21.0195 11.9976C21.0195 7.01597 16.9811 2.97758 11.9995 2.97758C7.01792 2.97758 2.97953 7.01597 2.97953 11.9976Z" fill="#333333"/>
      <mask id="mask0_1576_6900" maskUnits="userSpaceOnUse" x="2" y="2" width="20" height="20">
      <path fillRule="evenodd" clipRule="evenodd" d="M21.9795 11.9976C21.9795 17.5094 17.5113 21.9776 11.9995 21.9776C6.48773 21.9776 2.01953 17.5094 2.01953 11.9976C2.01953 6.48578 6.48773 2.01758 11.9995 2.01758C17.5113 2.01758 21.9795 6.48578 21.9795 11.9976ZM2.97953 11.9976C2.97953 16.9792 7.01792 21.0176 11.9995 21.0176C16.9811 21.0176 21.0195 16.9792 21.0195 11.9976C21.0195 7.01597 16.9811 2.97758 11.9995 2.97758C7.01792 2.97758 2.97953 7.01597 2.97953 11.9976Z" fill="white"/>
      </mask>
      <g mask="url(#mask0_1576_6900)">
      <rect width="24" height="24" fill="#999999"/>
      </g>
    </svg>
  )
}

export default MidStepCircle;